/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';
import PropTypes from 'prop-types';

import ViewDetail from '@spectrum-icons/workflow/ViewDetail';
import { ActionButton } from '@adobe/react-spectrum';

import classes from './ReferenceButton.scss';

const ReferenceButton = props => {
    const { onPress, label } = props;

    const customClasses = {
        UNSAFE_className: classes.root
    };

    return (
        <ActionButton onPress={onPress} data-test-id="button-view-selection" aria-label={label} {...customClasses}>
            <ViewDetail />
        </ActionButton>
    );
};

ReferenceButton.propTypes = {
    onPress: PropTypes.func,
    label: PropTypes.string
};

export default ReferenceButton;
